<template>
  <div>
    <v-card>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="addBadge()"> Add new badge </v-btn>
      </v-card-actions>
      <v-row v-if="$apollo.loading" align="center" justify="center">
        <v-col lg="6" md="8" sm="12">
          <v-skeleton-loader type="card, card, card" />
        </v-col>
      </v-row>
      <v-row v-else align="center" justify="center">
        <v-col lg="6" md="8" sm="12">
          <v-autocomplete
            v-model="search"
            multiple
            :items="badges"
            chips
            deletable-chips
            hide-selected
            :item-value="(val) => val.id"
            :item-text="(val) => val.title"
            label="Type to find a badge"
            clearable
            background-color="navy"
            dark
            rounded
            class="pt-0"
          />
          <v-card v-if="badges && badges.length == 0">
            <v-card-subtitle class="text-center">
              No {{ type }} badges to display
            </v-card-subtitle>
          </v-card>
          <badge-card
            v-for="badge in badges"
            :key="badge.id"
            :badge="badge"
            :type="type"
            @edit="editBadge(badge)"
          />
        </v-col>
      </v-row>
      <v-card-actions v-if="badges && badges.length > 4">
        <v-spacer />
        <v-btn @click="addBadge()"> Add new badge </v-btn>
      </v-card-actions>
    </v-card>

    <badge-dialog
      :badgeModal="badgeModal"
      :type="type"
      @close="badgeModal.show = false"
    />
  </div>
</template>

<script>
import BadgeListMixin from "./mixins/BadgeListMixin";

export default {
  name: "CoachBadges",
  mixins: [BadgeListMixin],
  data() {
    return {
      type: "coach",
    };
  },
};
</script>
